/* eslint no-param-reassign: 0 */

import React, { useState, useEffect } from "react"
import axios from "axios"
import * as qs from "query-string"
import propTypes from "prop-types"
import styled from "styled-components"
import { Box, Flex, Button, Text } from "rebass/styled-components"
import { Input, Textarea } from "@rebass/forms"

import withTranslation from "../i18n/withTranslation"
import useForm from "./useForm"

const Form = styled.form`
  max-width: 960px;
  margin: 0 auto;
`

const FormContent = styled.div`
  width: 100%;
  height: 100%;
  transition: all 1s ease;
  position: relative;
  margin-bottom: 50px;
`
const FormMessage = styled.div`
  transition: all 1s ease;
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s ease;
  top: 0;
  left: 0;
`

const Contact = ({ t, productName }) => {
  const formStateSchema = {
    name: { value: "", error: "" },
    email: { value: "", error: "" },
    message: { value: "", error: "" },
  }

  const [sending, setSending] = useState(false)
  const [successSubmit, setSuccess] = useState(false)
  const [requestError, setRequestError] = useState(false)

  useEffect(() => {
    setTimeout(() => setSuccess(false), 3000)
  }, [successSubmit])

  useEffect(() => {
    setTimeout(() => setRequestError(false), 3000)
  }, [requestError])

  const validationStateSchema = {
    name: {
      required: true,
      validator: {
        regEx: /^[a-zA-Z ]+$/,
        error: "Formato de nombre inválido.",
      },
    },
    email: {
      required: true,
      validator: {
        rule: "isEmail",
        error: "Formato de email inválido",
      },
    },
    message: {
      required: true,
    },
  }

  const onSubmitForm = state => {
    const data = {
      "form-name": "contact",
      name: state.name.value,
      email: state.email.value,
      message: state.message.value,
      product: productName,
    }

    setSending(true)

    const axiosOptions = {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }

    axios
      .post("/", qs.stringify(data), axiosOptions)
      .then(() => {
        setSuccess(true)
        setSending(false)
        // eslint-disable-next-line no-use-before-define
        clearForm()
      })
      .catch(() => {
        setRequestError(true)
        setSending(false)
      })
  }

  const { state, handleOnChange, handleOnSubmit, disable, clearForm } = useForm(
    formStateSchema,
    validationStateSchema,
    onSubmitForm
  )

  return (
    <div>
      <Form
        onSubmit={handleOnSubmit}
        data-netlify="true"
        name="contact"
        data-netlify-honeypot="bot-field"
      >
        <FormContent>
          {successSubmit && (
            <FormMessage>
              <Box>
                <Text color="primary">{t("contact.thanksMessage")}</Text>
              </Box>
            </FormMessage>
          )}
          <Input
            id="product"
            name="product"
            type="hidden"
            value={productName}
          />
          <Flex
            mx={[1]}
            mb={3}
            flexDirection={["column", "row"]}
            px={[1, 4, 2]}
          >
            <Box width={[1, 1 / 2]} px={[3, 4, 3]} my={[3]}>
              <Input
                id="name"
                name="name"
                type="text"
                required
                placeholder={t("contact.name")}
                onChange={handleOnChange}
                value={state.name.value}
                invalid={state.name.error}
              />
              {state.name.error}
            </Box>

            <Box width={[1, 1 / 2]} px={[3, 4, 3]} my={[3]}>
              <Input
                id="email"
                name="email"
                type="email"
                required
                placeholder={t("contact.email")}
                onChange={handleOnChange}
                value={state.email.value}
                invalid={state.email.error}
              />
              {state.email.error}
            </Box>
          </Flex>
          <Flex mx={[2, 1, -1]} mb={3}>
            <Box width={1} px={[3, 5, 4]}>
              <Textarea
                name="message"
                placeholder={t("contact.message")}
                required
                onChange={handleOnChange}
                value={state.message.value}
                invalid={state.message.error}
              />
              {state.message.error}
            </Box>
          </Flex>
          <Flex mx={[0, -4, -2]} py={[1, 3]} flexWrap="wrap" width={1}>
            <Box
              px={[1, 4, 3]}
              flexWrap="wrap"
              width={1}
              flexDirection="column"
              justify-content="center"
              textAlign={["center", "right"]}
            >
              <Button mt={2} disabled={disable}>
                {sending ? t("contact.sending") : t("contact.send")}
              </Button>
            </Box>
          </Flex>
          {requestError && (
            <Flex
              width={1}
              pt={[3]}
              flexDirection="column"
              justify-content="center"
            >
              <Text textAlign="center" color="red">
                {" "}
                {t("contact.errorMessage")}
              </Text>
            </Flex>
          )}
        </FormContent>
      </Form>
    </div>
  )
}

Contact.propTypes = {
  t: propTypes.func.isRequired,
  productName: propTypes.string,
}

export default withTranslation(Contact)
